module.exports = __webpack_public_path__ + "static/img/samajuri (6).efd38fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (6).jpg
// module id = WaG+
// module chunks = 0